import { Modal } from '@/components/Modal'
import { Button } from '@/components/Button'
import { Offer, OfferStatus, OfferUpdate } from '@graphql'
import { formatDateWithTime } from '@/utils/format'

type OfferHistoryModalProps = {
  open: boolean
  offer: Offer
  onClose: () => void
}

export function OfferHistoryModal({
  open,
  offer,
  onClose
}: OfferHistoryModalProps) {
  const updates = offer?.updates?.edges?.map(e => e?.node) ?? []

  const getButtons = () => {
    return (
      <div className="flex justify-end">
        <Button style="white" onClick={onClose}>
          Close
        </Button>
      </div>
    )
  }

  const getHistoryMessage = (update: OfferUpdate, location: string) => {
    let message
    const farmer = update?.user?.fullName ?? 'Someone'
    const status = update?.status

    if (update?.status === OfferStatus.Pending) {
      message = `You made an offer to ${location}`
    }
    if (
      status === OfferStatus.Rejected ||
      status === OfferStatus.Accepted ||
      status === OfferStatus.Acknowledged
    ) {
      message = `${farmer} has ${status?.toLowerCase()} this offer`
    }
    if (status === OfferStatus.Matched || status === OfferStatus.Expired) {
      message = `This offer has ${status?.toLowerCase()}`
    }
    if (status === OfferStatus.Canceled) {
      message = `You ${status?.toLowerCase()} this offer`
    }
    return message
  }

  return (
    <Modal
      title={`Offer History (#${offer?.displayId})`}
      onClose={onClose}
      open={open}
      buttons={getButtons()}
    >
      <div className="px-6 py-6 text-left">
        {updates?.map(update => {
          return (
            <div key={update?.id} className="mb-5">
              <p className="text-sm text-gray-500">
                {formatDateWithTime(update?.createdAt)}
              </p>
              <p>
                {getHistoryMessage(update, offer?.location?.name as string)}
              </p>
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
